// Copia en localStorage de los datos del usuario (rpc mi_acceso), para dibujar la app al instante al
// abrirla. La sesión de verdad es la de Supabase Auth: si no existe, la app vuelve al inicio de sesión.
const CLAVE_SESION = "usuario";

// Garantiza que miembro_id exista aunque solo venga el objeto miembro.
export function normalizarUsuario(usuario) {
  return {
    ...usuario,
    miembro_id: usuario?.miembro_id ?? usuario?.miembro?.id ?? null,
  };
}

export function cargarSesion() {
  const guardado = localStorage.getItem(CLAVE_SESION);
  if (!guardado) return null;
  try {
    const usuario = JSON.parse(guardado);
    // Las sesiones de la app anterior (Flask) o sin permisos ya no sirven.
    if (usuario?.origen !== "supabase" || !usuario?.acceso) throw new Error("Sesión anterior o sin permisos");
    return normalizarUsuario(usuario);
  } catch (e) {
    localStorage.removeItem(CLAVE_SESION);
    return null;
  }
}

export function guardarSesion(usuario) {
  localStorage.setItem(CLAVE_SESION, JSON.stringify(usuario));
}

export function cerrarSesion() {
  localStorage.removeItem(CLAVE_SESION);
}
